import React from 'react';
import PlayerCard from '../../pages/PlayerCard'

function Players() {
  return (
    <div className="players-page">
      <h1>Our Players</h1>
      <PlayerCard 
        name="John Doe" 
        role="Batsman" 
        image="/player-placeholder.png" 
      />
      {/* Add more players */}
    </div>
  );
}

export default Players;